/**
 * Normalize phone number to E.164 format (+996552764078)
 * Handles various input formats:
 * - +996552764078
 * - 00996552764078
 * - 996552764078
 * - 552764078 (with country code provided separately)
 */
export const normalizePhoneNumber = (phoneNumber, countryDialCode = '') => {
  if (!phoneNumber) return '';
  
  // Remove all spaces, dashes, parentheses
  let cleaned = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
  // If starts with 00, replace with +
  if (cleaned.startsWith('00')) {
    cleaned = '+' + cleaned.substring(2);
  }
  
  // If doesn't start with +, add the country code
  if (!cleaned.startsWith('+')) {
    if (countryDialCode) {
      // Remove + from country code if present
      const code = countryDialCode.replace('+', '');
      // Check if number already starts with country code digits
      if (!cleaned.startsWith(code)) {
        cleaned = '+' + code + cleaned;
      } else {
        cleaned = '+' + cleaned;
      }
    }
  }
  
  return cleaned;
};

/**
 * Format phone number for display
 * +996552764078 -> +996 552 764 078
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  const normalized = normalizePhoneNumber(phoneNumber);
  
  // Simple formatting: add spaces after country code
  if (normalized.startsWith('+')) {
    const parts = normalized.match(/^\+(\d{1,3})(\d+)$/);
    if (parts) {
      const [, countryCode, number] = parts;
      // Add space every 3 digits
      const formattedNumber = number.match(/.{1,3}/g)?.join(' ') || number;
      return `+${countryCode} ${formattedNumber}`;
    }
  }
  
  return normalized;
};

/**
 * Validate phone number
 */
export const isValidPhoneNumber = (phoneNumber) => {
  const normalized = normalizePhoneNumber(phoneNumber);
  // Basic validation: starts with + and has 7-15 digits
  const regex = /^\+\d{7,15}$/;
  return regex.test(normalized);
};

export default {
  normalizePhoneNumber,
  formatPhoneNumber,
  isValidPhoneNumber,
};
